// eslint-disable-next-line import/named
import { asMarkdownTemplate } from '../general/markdown';
import { createConfirmCancelButtons } from './modal-footer-buttons';
import { html, TemplateResult } from 'lit';
import { LitBaseModal } from './modal/modal-factory-lit';
import { Snippet } from '../../interop/webmodule-interop';
import { LangModalConfirmation } from '../../../localization/webmodule-common/other/ui/modal-confirmation-lang';
import { globalState } from './global-state';

export interface ConfirmButtons {
  ok: string;
  cancel: string;
}
export interface ConfirmButtonsProvider {
  ok: () => string;
  cancel: () => string;
}

export enum ConfirmationButtonType {
  yesNo = 0,
  okCancel = 1,
  continueCancel = 2,
  saveCancel = 3
}

export function buttonsYesNo() {
  return getConfirmationButtons()[ConfirmationButtonType.yesNo];
}

export function buttonsOkCancel() {
  return getConfirmationButtons()[ConfirmationButtonType.okCancel];
}

export function buttonsContinueCancel() {
  return getConfirmationButtons()[ConfirmationButtonType.continueCancel];
}

export function buttonsSaveCancel() {
  return getConfirmationButtons()[ConfirmationButtonType.saveCancel];
}

export async function AskConfirmation(
  message: string,
  confirmButtons?: ConfirmButtons,
  modalSize?: string,
  modalTitle?: string
): Promise<boolean> {
  if (!confirmButtons) confirmButtons = getConfirmationButtons()[ConfirmationButtonType.continueCancel];
  const modal: ConfirmationDialog = new ConfirmationDialog(message, confirmButtons, modalSize, modalTitle);
  await modal.showModal();
  return modal.result;
}

// noinspection HtmlUnknownAttribute

export class ConfirmationDialog extends LitBaseModal {
  message: string;
  result = false;
  buttons: ConfirmButtons;
  _modalSize = 'modal-md';
  _modalTitle = LangModalConfirmation.confirm();

  constructor(message: string, buttons: ConfirmButtons, modalSize?: string, modalTitle?: string) {
    super();
    this.message = message;
    this.buttons = buttons;

    if (modalSize) this._modalSize = modalSize;

    if (modalTitle) this._modalTitle = modalTitle;
  }

  footerTemplate(): TemplateResult {
    const okEvent = () => {
      this.result = true;
      this.hideModal();
    };
    const cancelEvent = () => {
      this.result = false;
      this.hideModal();
    };
    return createConfirmCancelButtons(this.buttons.ok, okEvent, this.buttons.cancel, cancelEvent);
  }

  bodyTemplate(): TemplateResult {
    return html` ${asMarkdownTemplate(this.message)} `;
  }

  title(): Snippet {
    return this._modalTitle;
  }
}

export function getConfirmationButtons(): ConfirmButtons[] {
  const gs = globalState();
  gs.confirmationButtons ??= [
    {
      ok: () => LangModalConfirmation.yes(),
      cancel: () => LangModalConfirmation.no()
    },
    {
      ok: () => LangModalConfirmation.ok(),
      cancel: () => LangModalConfirmation.cancel()
    },
    {
      ok: () => LangModalConfirmation.continue(),
      cancel: () => LangModalConfirmation.cancel()
    },
    {
      ok: () => LangModalConfirmation.saveAndClose(),
      cancel: () => LangModalConfirmation.cancel()
    }
  ];
  return gs.confirmationButtons.map(buttons => ({
    ok: buttons.ok(),
    cancel: buttons.cancel()
  })) as ConfirmButtons[];
}
